//  TODO: Clean this component up

class PageNav extends HTMLElement {
  constructor() {
    super();

    this.pageNavButtons = this.querySelector('.list-unstyled').querySelectorAll('.button');

    this.pageNavButtons.forEach((button) => {
      button.addEventListener('mouseover', () => {
        button.classList.add('list-menu__item--active-alternative');
      });
      button.addEventListener('mouseleave', () => {
        button.classList.remove('list-menu__item--active-alternative');
      });
    });
  }
}

customElements.define('page-nav', PageNav);
